
<button  class="custom-button" #tooltip="matTooltip" matTooltip="planifier une tâche" matTooltipPosition="left" (click)="planifierUneTache()">
    Planifier
  
    </button>
    <!-- Optionally, show a loading indicator -->
   
    
  